(function() {
  $(function() {
    var heading;
    heading = $('<h2 />').text('Login').prependTo('#loginform');
    if (document.URL.indexOf('nraa.com.au') === -1) {
      return $('<span \>').text('(Test)').appendTo(heading);
    }
  });

}).call(this);
